
export class pdfMakeJapanese {
    public static fontText = ""
    public static vfs = {
        "Roboto-Italic.ttf": "",
        "Roboto-Medium.ttf": "",
        "Roboto-MediumItalic.ttf": "",
        "Roboto-Regular.ttf": ""
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pdf/japanese-fonts.ts